import React from 'react'
import {TemplateTextContent} from "./TemplateTextContent";

const TemplateOne = ({activeTemplate, toggleModal, content, image1, image2, buttonComp, displayEditContentButton, publishActiveTemplate, canCustomize }) => {
  return (
    <div className='row template_one'>
      <div className={`col-md-3 col-sm-12 `}>
        <figure className='figure_img'><img src={image1} alt='nine to know placeholder'/></figure>
      </div>
      <div className={`col-md-6 col-sm-12 `}>
        <TemplateTextContent
          toggleModal={toggleModal}
          content={content}
          buttonComp={buttonComp}
          displayEditContentButton={displayEditContentButton}
          activeTemplate={activeTemplate}
          publishActiveTemplate={publishActiveTemplate}
          canCustomize={canCustomize}
        />
      </div>
      <div className={`col-md-3 col-sm-12 `}>
        <figure className='figure_img right'><img src={image2} alt='nine to know placeholder'/></figure>
      </div>
    </div>
  )
}

export default TemplateOne
